// extracted by mini-css-extract-plugin
export var link = "InfiniteScroll-module--link--f6afd";
export var loadMore = "InfiniteScroll-module--loadMore--ba704";